import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { withRouter } from 'next/router';
import { host } from '../hosts';

const Url = ({ content, router }) => {
  const url = host + router.asPath;

  return (
    <Head>
      <meta name="url" content={content || url} key="url" />
      <meta name="og:url" content={content || url} key="og:url" />
    </Head>
  );
};

Url.propTypes = {
  content: PropTypes.string,
  router: PropTypes.shape({ asPath: PropTypes.string }).isRequired,
};

Url.defaultProps = {
  content: null,
};

export default withRouter(Url);
